module.exports = __webpack_public_path__ + "img/ghost.a300b41d.png";